import { useState, MouseEvent } from "react"

export const useInputPopper = <TValue = any>(
  value: TValue,
  onChange: (newValue: TValue) => void = () => null,
  onSubmit: (newValue: TValue) => Promise<void> | void = async () => undefined,
  clearFormAndClose: () => void = () => null
) => {
  const [initialValue, setInitialValue] = useState<any>(value)
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null)

  const handleToggle = (e: MouseEvent<HTMLElement>) => {
    if (anchorEl) {
      handleClose()
    } else {
      setAnchorEl(e.currentTarget)
    }
  }

  const handleOpenPopper = (e: MouseEvent<HTMLElement>) => {
    if (!anchorEl) {
      setAnchorEl(e.currentTarget)
    }
  }

  const handleChange = (newValue: TValue) => onChange(newValue)

  const handleClose = () => {
    clearFormAndClose()
    onChange(initialValue)
    setAnchorEl(null)
  }

  const handleChangeAndClose = async (newValue: TValue) => {
    if (newValue === initialValue) {
      onChange(initialValue)
      return
    }

    try {
      onChange(newValue)
      await onSubmit(newValue)
      setInitialValue(newValue)
      clearFormAndClose()
    } catch (err) {
      onChange(initialValue)
      setInitialValue(initialValue)
    }
  }

  return {
    value,
    anchorEl,
    initialValue,
    handleToggle,
    handleOpenPopper,
    handleClose,
    handleChange,
    handleChangeAndClose,
  }
}
